export enum Variant {
  BUMPER = 'bumper',
  FLOATING_ACTION_BUTTON = 'floating-action-button',
  FLOATING_ACTION_CARD = 'floating-action-card',
  EMBEDDED = 'embedded',
}
